module.exports = __webpack_public_path__ + "img/collectiongallery_signet.3dc57c7.jpg";